import React from "react";
import styles from "./InvalidCharactersError.module.css";
import {
  DISALLOWED_CHARACTERS_MESSAGE,
  hasDisallowedCharacters,
} from "../../utils/beverageTextValidation";

export const InvalidCharactersError = ({ value, className }) => {
  if (!hasDisallowedCharacters(value)) {
    return null;
  }

  return (
    <span
      role="alert"
      className={[styles.error, className].filter(Boolean).join(" ")}
    >
      {DISALLOWED_CHARACTERS_MESSAGE}
    </span>
  );
};
